import styled from "styled-components";


export const Container = styled.footer`
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-top: 1px solid rgba(102, 126, 234, 0.2);
  padding: 2.5rem;
  margin-top: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1.4rem;
    color: #888;
    letter-spacing: 0.05rem;
    text-align: center;
    
    background: linear-gradient(135deg, #888 0%, #b8b8ff 50%, #888 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media(max-width: 600px){
    padding: 2rem 1rem;
    
    p {
      font-size: 1.2rem;
    }
  }
`